import { useMatches } from '@tanstack/react-location';

export const useMatchUser = () => {
  const matches = useMatches();
  const user = matches.find((match) => match.id !== 'root')?.data.user;
  return user;
};
